export default __webpack_public_path__ + "static/media/Pc5.252625b9.jpg";